let goodsData = [{
  "id": 1000271,
  "name": "屏幕电子钥匙",
  "name_title": "屏幕显示，按键，4G模块，实时授权，上传开锁记录",
  "model": "CG-SC-KEY-1",
  "sku_info": [{
    "sku_id": 1000271,
    "ali_image":require('@/assets/img/products/remotekey/screen/screenkey2.gif'),
    "spec_json": {
      "image": "attr/v2/1000271/948F029DCF134EF23267994487994DA5/",
      "show_name": "正面"
    }
  },{
    "sku_id": 1000271,
    "ali_image": require('@/assets/img/products/remotekey/screen/screenkey1.gif'),
    "spec_json": {
      "image": "attr/v2/1000271/649AD35E36A9703BACBE1555AEB6D266/",
      "show_name": "侧面"
    }
  }]
},{
  "id": 1000299,
  "name": "指纹电子钥匙",
  "name_title": "指纹认证，4G模块，实时授权，上报开锁记录",
  "model": 'CG-FG-KEY-1',
  "sku_info": [
  {
    "sku_id": 1000299,
    "title": "",
    "sub_title": "",
    "ali_image": require('@/assets/img/products/remotekey/finger/finger-key1.jpg'),
    "spec_json": {
      "image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
      "show_name": "正面"
    }
  },
    {
    "sku_id": 1000299,
    "title": "",
    "sub_title": "",
    "ali_image": require('@/assets/img/products/remotekey/finger/finger-key2.jpg'),
    "spec_json": {
      "image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
      "show_name": "侧面"
    }
  },
    {
    "sku_id": 1000299,
    "title": "",
    "sub_title": "",
    "ali_image": require('@/assets/img/products/remotekey/finger/finger-key3.jpg'),
    "spec_json": {
      "image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
      "show_name": "侧面"
    }
  }
  ]
},{
  "id": 1000300,
  "name": "按键电子钥匙",
  "name_title": "按键，4G模块，实时授权，上报开锁记录",
  "model": 'CG-BT-KEY-1',
  "sku_info": [
  {
    "sku_id": 1000300,
    "ali_image": require('@/assets/img/products/remotekey/buttonkey/btn-key1.jpg'),
    "spec_json": {
      "image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
      "show_name": "正面"
    }
  },
    {
    "sku_id": 1000300,
    "ali_image": require('@/assets/img/products/remotekey/buttonkey/btn-key3.jpg'),
    "spec_json": {
      "image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
      "show_name": "侧面"
    }
  },
    {
    "sku_id": 1000300,
    "ali_image": require('@/assets/img/products/remotekey/buttonkey/btn-key2.jpg'),
    "spec_json": {
      "image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
      "show_name": "侧面"
    }
  }
  ]
}
]

export default goodsData



// WEBPACK FOOTER //
// ./src/lib/remoteKeysData.js